export const TooltipDelays = {
  WITH_LINKS: 2500,
  WITHOUT_LINKS: 1500,
}
